//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import { commonApi } from "@/common/index";
import dayjs from "dayjs";
export default {
  name: "RedPacket",
  data() {
    return {
      rainItems: [], // 红包数组
      isStopped: false, // 是否停止红包雨
      rainDuration: 60000, // 红包雨持续时间
      interval: null, // 红包生成定时器
      clickedItem: null, // 当前被点击的红包
      moveInterval: null, // 红包移动定时器
      queryData: null,
      isRainStarted: false,
      winPrize: {},
      showCountDown: false,
    };
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.isLogin,
      isApp: (state) => state.isApp, //是否在app打开
    }),
  },
  watch: {
    isLogin() {
      this.queryRaffleData();
    },
  },
  activated() {
    this.queryRaffleData();
  },
  deactivated() {
    clearInterval(this.interval); // 清除定时器
    clearInterval(this.moveInterval); // 清除红包移动定时器
    this.rainItems = [];
    this.isStopped = false;
    this.interval = null;
    this.clickedItem = null;
    this.isRainStarted = false;
    this.winPrize = {};
    this.showCountDown = false;
  },
  methods: {
    queryRaffleData() {
      commonApi.DEPOSIT.queryTurntableRaffle({ activityType: 3 })
        .then((result) => {
          const { message, data } = result;
          // 是否关闭活动
          if (data === null) {
            this.$toast({
              message: message,
              icon: "warning",
            });
            return;
          }
          this.queryData = data;
          this.startListening();
        })
        .catch((err) => {
          this.$toast({
            message: err,
            icon: "warning",
          });
        });
    },
    // 监听当前时间是否在活动时间范围内
    startListening() {
      if (!this.isLogin) return;
      const { startTime, endTime } = this.queryData;
      const now = dayjs().valueOf();
      if (now < startTime) {
        this.$toast({
          message: "活动未开始",
          icon: "warning",
        });
        return;
      }
      if (now > endTime) {
        this.$toast({
          message: "活动已结束",
          icon: "warning",
        });
        return;
      }
      if (this.queryData.qhbUnusedCount <= 0) {
        this.$toast({
          message: "您的红包雨次数已用完",
          icon: "warning",
        });
        return;
      }

      if (!this.isRainStarted) {
        this.startTiming();
      }
    },

    startTiming() {
      this.showCountDown = true;
      setTimeout(() => {
        this.showCountDown = false;
        this.startRain();
      }, 5000);
    },
    // 开始红包雨
    startRain() {
      this.isRainStarted = true;
      const startTime = dayjs().valueOf();
      const boxWidth = this.$refs.redPacketContainer.offsetWidth;
      this.interval = setInterval(() => {
        if (dayjs().valueOf() - startTime >= this.rainDuration) {
          clearInterval(this.interval);
          return;
        }
        const id = `rain-${dayjs().valueOf()}-${Math.random()}`; // 唯一 ID
        const x = Math.random() * (boxWidth - 80); // 随机 X 坐标
        const speed = Math.random() * 2 + 5; // 随机下落速度
        this.rainItems.push({ id, x, y: -200, speed }); // 初始状态
      }, 300);
      this.moveRainItems();
    },

    // 移动红包
    moveRainItems() {
      this.moveInterval = setInterval(() => {
        if (this.isStopped && this.rainItems.length === 0) {
          clearInterval(this.moveInterval);
          return;
        }
        this.rainItems.forEach((item) => {
          item.y += item.speed; // 更新 Y 坐标
          if (item.y > window.innerHeight) {
            // 超出屏幕底部
            this.rainItems = this.rainItems.filter((i) => i.id !== item.id);

            if (this.rainItems.length <= 0) {
              this.stopRain();
            }
          }
        });
      }, 20);
    },

    // 获取红包的动态样式
    getItemStyle(item) {
      return {
        position: "absolute",
        left: `${item.x}px`,
        top: `${item.y}px`,
      };
    },

    // 点击红包
    handleClick(id) {
      const item = this.rainItems.find((i) => i.id === id);
      if (item) {
        this.clickedItem = item; // 记录点击的红包
        this.stopRain();
        commonApi.DEPOSIT.raffle({ activityType: 3 })
          .then((res) => {
            const { data, message } = res;
            if (!data) {
              this.$toast({
                message,
                icon: "warning",
              });
              return;
            }
            this.winPrize = data;
          })
          .catch((err) => {
            this.$toast({
              message: err || err.message,
              icon: "warning",
            });
          });
      }
    },

    // 停止红包雨
    stopRain() {
      if (!this.isStopped) {
        this.isStopped = true; // 标记停止
        clearInterval(this.interval); // 停止生成红包
        this.rainItems = []; // 清空红包数组

        if (!this.clickedItem) {
          this.handleBack();
        }
      }
    },

    close() {
      this.$toast({
        message: "领取成功",
        icon: "success",
        duration: 1000,
        onClose: () => {
          this.handleBack();
        },
      });
    },

    handleBack() {
      if (window.history.length < 2) {
        this.$router.push("/");
        return;
      }
      this.$router.go(-1);
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/redPacket/index.vue